<template>
	<div>
		<p v-if="address.company">
			{{ address.company }}
		</p>
		{{ address.full_name }}<br>
		{{ address.full_address }}<br>
		{{ address.zip_code }} {{ address.city }}<br>
		<p v-if="address.country_code === 'NL'">
			Nederland
		</p>
		<p v-if="address.country_code === 'BE'">
			België
		</p>

		<div class="inline-block">
			<vx-tooltip text="Stel email op">
				<a :href="`mailto:${address.email}?subject=${order.order.type_email_subject}&body=Beste ${address.full_name},`">Email
					klant</a>
			</vx-tooltip>
		</div>
		<div class="inline-block">
			<vx-tooltip text="Kopieer email adres">
				<font-awesome-icon class="fa-icon cursor-pointer ml-2"
								   :icon="['far', 'copy']"
								   style="font-size: 1.0rem"
								   @click="copyEmail" />
			</vx-tooltip>
		</div>
		<br>
	</div>
</template>

<script>
export default {
	props: {
		address: {
			type: Object,
			required: true,
		},
		order: {
			type: Object,
			required: true
		}
	},
	methods: {
		copyEmail() {
			this.$copyText(this.address.email).then(result => {
				this.$vs.notify({
					title: 'Yes!',
					text: 'Dit email adres is succesvol naar je klembord gekopieerd!',
					color: 'success',
				});
			}).catch(error => {
				this.$vs.notify({
					title: 'Oops!',
					text: 'Het kopiëren is mislukt!',
					color: 'danger',
				});
			});
		},
	}
}
</script>
